"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _setHotspot = _interopRequireDefault(require("./setHotspot"));
var _formMixin = _interopRequireDefault(require("../../formMixin"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CarouselForm',
  components: {
    SetHotspotVue: _setHotspot.default
  },
  mixins: [_formMixin.default],
  data: function data() {
    return {
      initData: {
        url: '',
        pic: '',
        name: ''
      },
      form: {
        showType: 5,
        imgActPadding: {
          pt: 0,
          pb: 0,
          pl: 15,
          pr: 15
        }
      },
      itemIndex: null
    };
  },
  watch: {
    propsData: {
      handler: function handler(propsData) {
        var _this$form;
        this.form = Object.assign(this.form, propsData);
        if (!((_this$form = this.form) !== null && _this$form !== void 0 && _this$form.imgActPadding)) {
          this.$set(this.form, 'imgActPadding', {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          });
        }
        ;
      },
      immediate: true,
      deep: true
    }
  },
  methods: _defineProperty({
    setHotspot: function setHotspot() {
      if (this.form.pic) {
        this.$refs.setHotspotVueRef.open(this.form);
      } else {
        this.$message.warning('请先上传图片');
      }
    },
    uploadImg: function uploadImg() {
      var _this = this;
      this.$modalUpload(function () {
        var _data$;
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var forms = JSON.parse(JSON.stringify(_this.form));
        forms["pic"] = data[0].sattDir;
        _this.form = forms;
        if (!(data !== null && data !== void 0 && (_data$ = data[0]) !== null && _data$ !== void 0 && _data$.sattDir)) return;
        _this.setImageNaturalSize(data[0].sattDir);
      });
    },
    setImageNaturalSize: function setImageNaturalSize(url) {
      var _this2 = this;
      if (!url) return;
      var image = new Image();
      image.onload = function () {
        _this2.$set(_this2.form, 'picW', image.naturalWidth || image.width || 0);
        _this2.$set(_this2.form, 'picH', image.naturalHeight || image.height || 0);
      };
      image.onerror = function () {
        console.warn('无法获取图片尺寸', url);
      };
      image.src = url;
    },
    updateForm: function updateForm(data) {
      this.form = _objectSpread(_objectSpread({}, this.form), data);
    }
  }, "setImageNaturalSize", function setImageNaturalSize(url) {
    var _this3 = this;
    if (!url) return;
    var image = new Image();
    image.onload = function () {
      _this3.form = _objectSpread(_objectSpread({}, _this3.form), {}, {
        picW: image.naturalWidth || image.width || 0,
        picH: image.naturalHeight || image.height || 0
      });
    };
    image.onerror = function () {
      console.warn('无法获取图片尺寸', url);
    };
    image.src = url;
  })
};